import { useContext, useState } from "react";
import "./index.scss";
import { Card, Divider, Flex, Form, Input, Space, Typography } from "antd";
import Button from "../../Components/Atoms/DynamicButton";
import AuthService from "../../Services/auth.service";
import SuccessResult from "../../Components/Atoms/SuccessResult/SuccessResult";
import FailureResult from "../../Components/Atoms/FailureResult/FailureResult";
import { useNavigate } from "react-router-dom";
import LoaderContext from "../../Context/LoaderContext/Index";

const failureReason = ["Entered email not found"];

const ForgotPassword = () => {
  const { setLoading } = useContext(LoaderContext);
  const navigate = useNavigate();
  const authService = AuthService.getInstance();
  const [showFailure, setShowFailure] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const { isLoading } = useContext(LoaderContext);

  const handleEmailSubmit = async (values: any) => {
    setLoading(true);
    const response = await authService.sendPasswordResetMail(values.email);
    if (response?.status === 201) {
      setLoading(false);
      setShowSuccess(true);
    } else {
      setLoading(false);
      setShowFailure(true);
    }
  };

  const handleTryAgain = () => {
    setShowFailure(false);
    setShowSuccess(false);
  };

  const handleOk = () => {
    navigate("/");
  };

  return (
    <Flex className="signin" align="start" justify="center">
      {!showSuccess && !showFailure && (
        <Card
          className="card"
          style={{ maxWidth: 360, width: "100%" }}
          bordered
          title={
            <Divider orientation="left">
              <Typography.Title level={4} style={{ margin: 0 }}>
                Forgot Password
              </Typography.Title>
            </Divider>
          }
        >
          <Form
            name="email_form"
            onFinish={handleEmailSubmit}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Please enter a valid email address!",
                },
              ]}
            >
              <Input placeholder="Registered Email" />
            </Form.Item>
            <Flex gap={16} style={{ width: "100%" }}>
              <Button block type="default" onClick={() => navigate("/sign-in")} style={{ width: "100%" }}>
                Back to Sign In
              </Button>
              <Button
                block
                type="primary"
                htmlType="submit"
                loading={isLoading}
                style={{ width: "100%" }}
              >
                Next
              </Button>
            </Flex>
          </Form>
        </Card>
      )}

      {showSuccess && !showFailure && (
        <SuccessResult
          title="Mail Sent"
          subTitle="A password reset link has been sent to your email. Please check your inbox to reset your password."
          onClick={handleOk}
          buttonTitle="Go Back"
        />
      )}

      {showFailure && !showSuccess && (
        <FailureResult
          title="Request Failed"
          subTitle="Your password reset request failed due to the following reasons:"
          reason={failureReason}
          onClick={handleTryAgain}
        />
      )}
    </Flex>
  );
};

export default ForgotPassword;
